import { render } from "./TheList.vue?vue&type=template&id=64cb45a3&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=ts"
export * from "./TheList.vue?vue&type=script&lang=ts"

import "./TheList.vue?vue&type=style&index=0&id=64cb45a3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64cb45a3"

export default script